import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const AccessControlDashboard = lazy(() => import('./pages/AccessControlDashboard'));
const UserManagement = lazy(() => import('./pages/UserManagement'));
const RoleManagement = lazy(() => import('./pages/RoleManagement'));
const PermissionManagement = lazy(() => import('./pages/PermissionManagement'));
const SystemSettings = lazy(() => import('./pages/SystemSettings'));
const RolePermissions = lazy(() => import('./pages/RolePermissions'));

const accessControlRoutes: RouteObject[] = [
  {
    path: '',
    element: <AccessControlDashboard />,
  },
  {
    path: 'users',
    element: <UserManagement />,
  },
  {
    path: 'roles',
    element: <RoleManagement />,
  },
  {
    path: 'roles/:roleId/permissions',
    element: <RolePermissions />,
  },
  {
    path: 'permissions',
    element: <PermissionManagement />,
  },
  {
    path: 'settings',
    element: <SystemSettings />,
  },
];

export default accessControlRoutes;
